// src/encrypt/encrypt.ts
import CryptoJS from "crypto-js";
var encrypt = (data, { cryptoKey, cryptoIv }) => {
  const cipher = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(cryptoKey), {
    iv: CryptoJS.enc.Utf8.parse(cryptoIv)
  });
  const checksum = CryptoJS.SHA512(cipher.toString());
  return {
    json: cipher.toString(),
    sum: checksum.toString()
  };
};

// src/decrypt-asym/decrypt-asym.ts
import CryptoJS2 from "crypto-js";
import forge from "node-forge";
var decryptAsym = (data, { cryptoPrivateKey }) => {
  const privateKey = forge.pki.privateKeyFromPem(cryptoPrivateKey);
  const decryptedKeys = privateKey.decrypt(atob(data.key), "RSA-OAEP", {
    md: forge.md.sha256.create(),
    mgf1: {
      md: forge.md.sha1.create()
    }
  });
  const [cryptoKey, cryptoIv] = decryptedKeys.split("|");
  const rawData = CryptoJS2.enc.Base64.parse(data.json);
  const decryptedDataBuffer = CryptoJS2.AES.decrypt(
    { ciphertext: rawData },
    CryptoJS2.enc.Utf8.parse(cryptoKey),
    {
      iv: CryptoJS2.enc.Utf8.parse(cryptoIv)
    }
  );
  const decryptedData = decryptedDataBuffer.toString(CryptoJS2.enc.Utf8);
  if (CryptoJS2.SHA512(decryptedData).toString() !== data.sum)
    throw new Error("DECRYPTION FAILED");
  return JSON.parse(decryptedData);
};

// src/encrypt-asym/encrypt-asym.ts
import CryptoJS3 from "crypto-js";
import { nanoid } from "nanoid";
import forge2 from "node-forge";
var encryptAsym = (data, { cryptoPublicKey }) => {
  const cryptoKey = nanoid(16);
  const cryptoIv = nanoid(16);
  const cipher = CryptoJS3.AES.encrypt(JSON.stringify(data), CryptoJS3.enc.Utf8.parse(cryptoKey), {
    iv: CryptoJS3.enc.Utf8.parse(cryptoIv)
  });
  const checksum = CryptoJS3.SHA512(JSON.stringify(data));
  const publicKey = forge2.pki.publicKeyFromPem(cryptoPublicKey);
  const key = btoa(
    publicKey.encrypt(cryptoKey + "|" + cryptoIv, "RSA-OAEP", {
      md: forge2.md.sha256.create(),
      mgf1: {
        md: forge2.md.sha1.create()
      }
    })
  );
  return {
    json: cipher.toString(),
    sum: checksum.toString(),
    key
  };
};

// src/decrypt/decrypt.ts
import CryptoJS4 from "crypto-js";
var decrypt = (data, { cryptoKey, cryptoIv }) => {
  if (CryptoJS4.SHA512(data.json).toString() !== data.sum)
    throw new Error("DECRYPTION FAILED");
  const rawData = CryptoJS4.enc.Base64.parse(data.json);
  const plaintextData = CryptoJS4.AES.decrypt(
    { ciphertext: rawData },
    CryptoJS4.enc.Utf8.parse(cryptoKey),
    {
      iv: CryptoJS4.enc.Utf8.parse(cryptoIv)
    }
  );
  return JSON.parse(plaintextData.toString(CryptoJS4.enc.Utf8));
};
export {
  decrypt,
  decryptAsym,
  encrypt,
  encryptAsym
};
